// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Action name of a permission.
// Example: "TiskoveDavky"

export const permissionActionNameMinLength = 1;
export const permissionActionNameMaxLength = 128;

export const PermissionActionNameSchema = t.refinement(t.string, n => n.length >= permissionActionNameMinLength && n.length <= permissionActionNameMaxLength, 'PermissionActionName');

export type PermissionActionName = string;
